
define('text!templates/appMain/privilegedMain/qm/policies/editors/queuesSelector.html',[],function () { return '<input type="hidden" class="queueSelector" data-bind="\n                        combobox: {\n                            search: getQueues,\n                            value: queues,\n                            placeholder: placeholderText\n                        }">';});

